module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"currentPass":"Текущий пароль","newPass":"Новый пароль","confirmPass":"Подтверждение пароля","changePass":"Изменить пароль","passChanged":"Пароль изменен"}}')
  delete Component.options._Ctor
}
